import addWindowScrollPositionToDocument from './modules/viewport';
import './modules/modal';
import './modules/navigation';
import './modules/dropdown';
import initTestimonialsSlider from './modules/testimonials';
import initEmployeesSlider from './modules/employees';

try {
    window.$ = window.jQuery = require('jquery');

    // Bootstrap elements example
    // require('bootstrap');
} catch (e) {
}

addWindowScrollPositionToDocument();
initTestimonialsSlider();
initEmployeesSlider();
